import * as React from 'react';
import * as styled from './styled';
import {TotalEnergyProps} from './types';

/**
 * The total energy counter.
 * @param {TotalEnergyProps} props
 * @return {React.ReactElement<TotalEnergyProps>}
 * @constructor
 */
export default function TotalEnergy(
    props: TotalEnergyProps,
): React.ReactElement<TotalEnergyProps> {
  const kcal = props.ingredients.map((
    (ingredient) => (
      ingredient.energy.kcal
    )
  )).reduce((
    (prev, current) => (
      Number(prev) + Number(current)
    )
  ), 0);

  const proteins = props.ingredients.map((
    (ingredient) => (
      ingredient.energy.proteins
    )
  )).reduce((
    (prev, current) => (
      Number(prev) + Number(current)
    )
  ), 0);

  const fats = props.ingredients.map((
    (ingredient) => (
      ingredient.energy.fats
    )
  )).reduce((
    (prev, current) => (
      Number(prev) + Number(current)
    )
  ), 0);

  const ch = props.ingredients.map((
    (ingredient) => (
      ingredient.energy.ch
    )
  )).reduce((
    (prev, current) => (
      Number(prev) + Number(current)
    )
  ), 0);

  return (
    <styled.Wrapper>
      <styled.Item>
        <span>Калории</span>
        {kcal}
      </styled.Item>
      <styled.Item>
        <span>Белки</span>
        {proteins}
        г
      </styled.Item>
      <styled.Item>
        <span>Жиры</span>
        {fats}
        г
      </styled.Item>
      <styled.Item>
        <span>Углеводы</span>
        {ch}
        г
      </styled.Item>
    </styled.Wrapper>
  );
}
